export default function generateRandomImagePlacePath(
  id,
  objOrStringServicesTypes
) {
  if (!id || typeof id !== "string") {
    return "/business_picture_placeholder.jpg";
  }
  const imgNum = parseInt(id.slice(-3), 16);
  const dict = { groomer: 46, trainer: 50, veterinary: 42 };
  const fract = (imgNum + 1) / 4096;

  const last = parseInt(id[id.length - 1], 16) + 1;
  let initialSt = "";
  if (last > 8) {
    initialSt = "trainer";
  } else {
    initialSt = "groomer";
  }
  const serviceTypes = objOrStringServicesTypes?.map((st) => {
    if (typeof st === "object") {
      return st.attributes.name;
    }
    if (typeof st === "string") {
      return st;
    }
    return "";
  });
  let j = Math.ceil(fract * dict[initialSt]);
  if (!Array.isArray(serviceTypes) || !serviceTypes.length) {
    return `/business_image_placeholders/${initialSt}_${j}.jpg`;
  }

  const searchString = serviceTypes?.join("")?.toUpperCase();
  const grooming = searchString.includes("GROOMING");
  const veterinary = searchString.includes("VETERINARY");
  const training = searchString.includes("TRAINING");

  if (grooming && training) {
    return `/business_image_placeholders/${initialSt}_${j}.jpg`;
  }
  if (grooming) {
    j = Math.ceil(fract * dict.groomer);
    return `/business_image_placeholders/groomer_${j}.jpg`;
  }
  if (training) {
    j = Math.ceil(fract * dict.trainer);
    return `/business_image_placeholders/trainer_${j}.jpg`;
  }
  if (veterinary) {
    j = Math.ceil(fract * dict.veterinary);
    return `/business_image_placeholders/veterinary_${j}.jpg`;
  }
  return `/business_image_placeholders/${initialSt}_${j}.jpg`;
}
